import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Option extends Component {
  constructor(props) {
    super(props);

    this.optDom = React.createRef();
  }
  selectOpt = () => {
    this.props.selectOption(this.props.optId);
  };
  mouseOver = () => {
    let rect = this.optDom.current.getBoundingClientRect();
    this.props.mouseOver(rect, this.props.tips);
  };
  hideTips = () => {
    this.props.hideTips();
  };
  render() {
    if (this.props.disabled) {
      return (
        <div
          className="option inactive hover-tip"
          ref={this.optDom}
          onMouseEnter={this.mouseOver}
          onMouseLeave={this.hideTips}
        >
          {this.props.content}
        </div>
      );
    } else {
      var className = this.props.selected ? 'option selected' : 'option';

      return (
        <div className={className} onClick={this.selectOpt}>
          {this.props.content}
        </div>
      );
    }
  }
}

// PropTypes
Option.propTypes = {
  optId: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  selectOption: PropTypes.func.isRequired,
  mouseOver: PropTypes.func,
  disabled: PropTypes.bool,
  tips: PropTypes.string,
  hideTips: PropTypes.func,
};

export default Option;
